export enum BankingPartner {
  Ibc = 'IBC',
  Desjardins = 'DESJARDINS',
  Intercard = 'INTERCARD',
  Bbx = 'BBX',
}
